<template>
  <div>
    <page-header :title="title" />
    <form @submit.prevent="gravar">
      <div class="modal-body">
        <div class="form-horizontal">
          <vue-element-loading :active="isActive" spinner="bar-fade-scale" color="#428BCA" />

          <input-form-text textInput="Título" :required="true" v-model="form.titulo" :value="form.titulo" />

          <div class="form-group">
            <label class="col-sm-3 control-label no-padding-right">Texto</label>
            <div class="col-sm-9">
              <editor v-model="form.texto" style="height: 280px">
                <editor-tool :name="'formatting'" />
                <editor-tool :name="'bold'" />
                <editor-tool :name="'italic'" />
                <editor-tool :name="'underline'" />
                <editor-tool :name="'fontSize'" />
                <editor-tool :name="'foreColor'" />
                <editor-tool :name="'undo'" />
                <editor-tool :name="'redo'" />
                <editor-tool :name="'viewHtml'" />
                <editor-tool :name="'justifyLeft'" />
                <editor-tool :name="'justifyCenter'" />
                <editor-tool :name="'justifyRight'" />
                <editor-tool :name="'justifyFull'" />
                <editor-tool :name="'cleanFormatting'" />
                <editor-tool :name="'insertUnorderedList'" />
                <editor-tool :name="'insertOrderedList'" />
                <editor-tool :name="'indent'" />
                <editor-tool :name="'outdent'" />
                <editor-tool :name="'createLink'" />
                <editor-tool :name="'unlink'" />
                <editor-tool :name="'print'" />
              </editor>
            </div>
          </div>

          <div class="form-group">
            <label class="col-sm-3 control-label no-padding-right">Selecione</label>
            <div class="col-sm-5">
              <div class="radio">
                <label>
                  <input name="form-field-radio" type="radio" class="ace" value="1" v-model="select" />
                  <span class="lbl"> Arquivo</span>
                </label>
              </div>
              <div class="radio">
                <label>
                  <input name="form-field-radio" type="radio" class="ace" value="2" v-model="select" />
                  <span class="lbl"> Link</span>
                </label>
              </div>
            </div>
          </div>

          <div v-if="select == 2">
            <input-form-text textInput="URL" v-model="form.url" :value="form.url" />
          </div>
          <div class="form-group" v-else>
            <label class="col-sm-3 control-label no-padding-right"></label>
            <div class="col-sm-5">
              <file-upload
                v-if="!allFiles.length"
                ref="fupload"
                :url="'/v1/licitacoes-comunicados/upload'"
                :id="null"
                :label="'PDF até 10 MB'"
                :multiple="false"
                texto="Enviar Arquivos"
                accept=".pdf"
                :isFile="true"
              />
              <items-edit
                v-else
                :files="allFiles"
                url="/v1/licitacoes-comunicados/upload"
                id="id"
                :isFile="true"
              />
            </div>
          </div>

          <div class="form-group">
            <select-form v-model="form.ativo" :value="form.ativo" name="Ativo" url="/arquivos" id="id" titulo="nome" layout="true" optionText="Selecione" required="true" />
          </div>
        </div>
      </div>
      <footer-button :disabled="isActiveBtn" />
    </form>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'
import fileUpload from '@/components/form/file-upload/Index'
import ItemsEdit from '@/components/form/file-upload/ItemsEdit'
import '@progress/kendo-ui'
import '@progress/kendo-ui/css/web/kendo.default-v2.min.css'
import '@progress/kendo-ui/js/cultures/kendo.culture.pt-BR'
import '@progress/kendo-ui/js/messages/kendo.messages.pt-BR'
import { Editor, EditorTool, EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

Vue.use(EditorInstaller)

const TITULO_PADRAO = 'JUSTIFICATIVA PARA INEXIGIBILIDADE DE CHAMAMENTO PÚBLICO DA ASSOCIAÇÃO XXXX (o nome das entidades consta no arquivo em anexo).'

export default {
  components: {
    PageHeader,
    InputFormText,
    FooterButton,
    SelectForm,
    VueElementLoading,
    Editor,
    EditorTool,
    fileUpload,
    ItemsEdit
  },
  mixins: [Permission],
  computed: {
    ...mapGetters(['user'])
  },
  data() {
    return {
      title: 'Avisos e  Comunicados',
      form: {
        titulo: TITULO_PADRAO,
        texto: '',
        url: '',
        ativo: '1'
      },
      allFiles: [],
      select: '1',
      isActiveBtn: false,
      isActive: false
    }
  },
  methods: {
    ...mapActions(['getLogsTotal']),
    buildSaveBody() {
      const body = { ...this.form }
      const u = (body.url || '').trim()
      if (String(this.select) === '1') {
        delete body.url
        return body
      }
      if (!u) {
        delete body.url
      }
      return body
    },
    async gravar() {
      this.isActive = true
      this.isActiveBtn = true
      const body = this.buildSaveBody()
      try {
        let resp
        if (this.$route.params.id) {
          resp = await req(`/v1/licitacoes-comunicados/${this.$route.params.id}`, 'put', body)
        } else {
          resp = await req('/v1/licitacoes-comunicados', 'post', body)
        }
        if (this.$refs.fupload) {
          const tb = this.$refs.fupload.$children.filter(i => i.$refs.tb)
          const m = tb[0]
          await m.uploadAll(resp)
        }
        sucesso('Atualizado...')
        this.getLogsTotal(this.user.id)
        this.$router.push('/servicos/licitacoes-comunicados')
      } catch (e) {
        erro()
      } finally {
        this.isActive = false
        this.isActiveBtn = false
      }
    },
    async getDados() {
      try {
        const resp = await req(`/v1/licitacoes-comunicados/${this.$route.params.id}`)
        this.form.ativo = resp.ativo
        this.form.titulo = resp.titulo
        this.form.texto = resp.texto
        const raw = (resp.url_armazenamento != null && resp.url_armazenamento !== '')
          ? String(resp.url_armazenamento).trim()
          : ''
        if (raw && /^https?:\/\//i.test(raw)) {
          this.select = '2'
          this.form.url = raw
          this.allFiles = []
        } else if (raw) {
          this.select = '1'
          this.form.url = ''
          this.allFiles = resp.url ? [{ id: this.$route.params.id, files: resp.url }] : []
        } else {
          this.select = '1'
          this.form.url = ''
          this.allFiles = []
        }
      } catch (e) {
        erro()
      } finally {
        this.isActive = false
      }
    },
    verifPermissao() {
      if (this.$route.params.id && !this.ACTION.e) {
        this.$router.push('/erro')
      } else if (!this.$route.params.id && !this.ACTION.c) {
        this.$router.push('/erro')
      }
    }
  },
  mounted() {
    this.verifPermissao()
    if (this.$route.params.id) {
      this.isActive = true
      this.getDados()
    } else {
      this.form.titulo = TITULO_PADRAO
    }
  }
}
</script>
